import { useSelector } from "react-redux";
import Logo from "../../images/logo.png";
import { motion, useAnimation, AnimatePresence } from "framer-motion";

const Results = () => {
  const resultData = useSelector((state) => state.question.results);
  const backgrounds = [
    ["#F93D78", "#E77E5B"],
    ["#FF6471", "#FF3E96"],
    ["#FDBB62", "#FF7545"],
    ["#F93D78", "#E77E5B"],
  ];
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          transition: { delay: 0.5, duration: 0.5 },
        }}
        exit={{ opacity: 0 }}
      >
        <div className="h-screen flex flex-col max-h-[900px]">
          {/* <div className="bg-white p-6 py-5">
        <img src={Logo} alt="" className="w-20" />
      </div> */}

          <div className="flex flex-col flex-1">
            <div className="my-8 px-6">
              <h2
                className={"font-headline uppercase text-3xl text-white mb-3"}
              >
                The results are in...
              </h2>

              <p className="font-body font-normal text-lg text-white">
                You're doing well, here's some things to consider
              </p>
            </div>

            <div
              className="relative w-full flex gap-6 snap-x  snap-proximity snap-mandatory overflow-x-auto no-scrollbar flex-1"
              style={{
                "-webkit-overflow-scrolling": "touch",
              }}
            >
              {resultData.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={`snap-center shrink-0 w-4/5 bg-white rounded-md pb-4  overflow-hidden max-h-[700px] ${
                      i == 0 && "ml-6"
                    } ${resultData.length - 1 == i && "mr-6"}`}
                  >
                    <div
                      style={{
                        backgroundImage: `linear-gradient(to right, ${backgrounds[i][0]}, ${backgrounds[i][1]})`,
                      }}
                    >
                      <h2
                        className={
                          "p-5 px-4 font-headline text-2xl text-white uppercase"
                        }
                      >
                        {item.type}
                      </h2>
                    </div>

                    <div
                      className="aspect-w-16 aspect-h-9 bg-cover bg-center mx-4 my-5"
                      style={{
                        backgroundImage: `url(${item.image})`,
                      }}
                    />

                    <div className="px-4">
                      <p
                        className="my-2 font-body text-base"
                        style={{ color: "#3F3E57" }}
                      >
                        {item.resultCopy}
                      </p>
                      <a href="https://www.getmoneycoach.co.uk/">
                        <span
                          className="font- font-bold text-base"
                          yarn
                          st
                          style={{ color: "#FF3E96" }}
                        >
                          {item.resultLinkCopy}
                        </span>
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
            <a href="https://www.getmoneycoach.co.uk/" className="px-6">
              <div
                className={"my-7 rounded-md p-3 py-4 flex justify-center"}
                style={{ backgroundColor: "#FF3E96" }}
              >
                <span className="font-medium text-white">
                  Get started for free today!
                </span>
              </div>
            </a>
            <div className="pb-2 text-center px-3 -z-50">
              <a href="https://www.getmoneycoach.co.uk/privacy-policy">
                <span className="text-[14px] leading-[10px] opacity-70 text-white pb-20">
                  You can find out how we use your data and how to contact us
                  with any queries <i className="underline not-italic">here</i>.
                </span>
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Results;
